import styled from 'styled-components';

import Checkbox from '@mui/material/Checkbox';
import Chip from '@sdb/ui/atoms/Chip';

import { Icon } from '@sdb/planning-ui';

const Styles = styled.div`
  position: relative;
  height: 0;

  .checkbox {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 100%;
  }

  .chip {
    visibility: hidden;
  }
`;

type Props = {
  checked: boolean;
  label: string;
  onClick: () => void;
};

export default function CellCheckAll({ checked, onClick, label }: Props) {
  return (
    <th>
      <Styles>
        <Checkbox
          size="small"
          className="checkbox"
          checked={checked}
          onClick={onClick}
          icon={<Icon type="circle-check" />}
          checkedIcon={<Icon type="circle-check-solid" color="primary" />}
        />
        <Chip label={label} className="chip" />
      </Styles>
    </th>
  );
}
